// extracted by mini-css-extract-plugin
export default {"container":"SelectInputForm_container__fGsPG","label":"SelectInputForm_label__+9Y4j"};